import React from 'react'

import { Button } from 'elements/button/Button'
import { Div } from 'elements/layout/Div'
import { Span } from 'elements/layout/Span'
import { Link } from 'elements/text/Link'
import { Text } from 'elements/text/Text'

import { PAGE } from 'routes/constants'

import type { TCommunity } from 'modules/community/types'

export type TPreviewingCommunityBannerProps = {
  community: TCommunity
  isDraft?: boolean
  isCheck?: boolean
}

/**
 * ### PreviewingCommunityBanner ###
 */
export const PreviewingCommunityBanner: TFC<TPreviewingCommunityBannerProps> = ({ community, isDraft, isCheck }) =>
  isCheck || isDraft ? (
    <Div noOverflow bg="yellow" color="white" p="4px 7px" noPrint>
      <Text p="11px 12px">{isDraft ? 'trans:community:community.preview' : 'trans:community:community.reviewing'}</Text>
      <Span right>
        {isDraft && (
          <Link
            to={{
              pathname: PAGE.COMMUNITY_EDIT,
              query: {
                communityId: community.id,
                communitySlug: community.slug,
              },
            }}
          >
            <Button m="3px">trans:community:word.edit</Button>
          </Link>
        )}
      </Span>
    </Div>
  ) : null
